import React, { useState, useEffect } from 'react';
import axios from '../../api/api';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const MakeReview = () => {
  const [view, setView] = useState('');
  const { id } = useParams();
  const [redirectLink, setRedirectLink] = useState(`https://naijaprime.vercel.app/viewer/viewvideo/${id}`);
  const [productLink, setProductLink] = useState([])
  

  useEffect(() => {
    const getVideoById = async () => {
      try {
        const response = await axios.get(`/api/v3/stream/${id}`, { responseType: 'blob' });
        const videoBlob = new Blob([response.data], { type: 'video/mp4' });
        const url = URL.createObjectURL(videoBlob);
        setView(url);
        console.log(url);
      } catch (error) {
        console.error('Error fetching video:', error.message);
        console.error(error);
      }
    };
    getVideoById();
  }, [id]);

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 4000));
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await axios.put(`/api/v3/content/updatelinks/${id}`, {
        productLink,
        redirectLink
      });
      toast.success('Link Updated')
    } catch (error) {
      toast.error('Failed To Updated')
      console.error('Error updating link:', error);
    }
  }

  return (
    <div>
      <div className='container mx-auto p-4'>
        <h1 className='text-3xl font-bold text-center my-8'>Make Review</h1>
        <div className='flex items-center justify-center'>
          {isLoading
            ? (
              <div>
                <h1>Video Loading...</h1>
              </div>
              )
            : (
              <div>
                {view.length > 0
                  ? (
                    <div>
                      <video width='1200' height='190' muted controls>
                        <source src={view} type='video/mp4' />
                        <source src='video.ogg' type='video/ogg' />
                      </video>
                      <div>
                        <form onSubmit={handleSubmit}>
                          <div className=' py-4 gap-3'>
                            <label htmlFor="link">
                              <input 
                                type="text"
                                className='px-3 py-2 mb-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                                required
                                placeholder='Video Redirect link'
                                value={redirectLink}
                                onChange={(e) => setRedirectLink(e.target.value)}
                              />
                            </label>
                            <label htmlFor="link">
                              <input 
                                type="text"
                                className='px-3 py-2 mb-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                                required
                                placeholder='Video product link'
                                value={productLink}
                                onChange={(e) => setProductLink(e.target.value)}
                              />
                            </label>
                            <button className='bg-blue-600 text-white px-5 py-2 rounded-md'>Add</button>
                          </div>
                        </form>
                      </div>
                    </div>
                    )
                  : (
                    <span>A minite please</span>
                    )}
              </div>
              )}
        </div>
      </div>
    </div>
  );
};

export default MakeReview;
